import { useEffect, useReducer, useState } from 'react';
import { getDataUrl } from '../../../../services/MediaFileService/MediaFileService';
import { useAppSelector } from 'src/store/hooks';

type Properties = {
    dbId: string;
    autoplay?: boolean;
    showErrorMessage?: boolean;
};

type Action = {
    type: 'SET_AUDIO';
    data: string;
};

const reducer = (state: string, action: Action) => {
    if (action.type === 'SET_AUDIO') {
        return action.data;
    }
    return state;
};

const DbAudio = (props: Properties) => {
    const { dbId, autoplay } = props;

    const [ audioFile, dispatch ] = useReducer(reducer, '');
    const [isLoading, setIsLoading] = useState(true);
    const studyId = useAppSelector(state => state.globalState.user?.studyId);

    useEffect(() => {
        setIsLoading(true);

        const loadAudio = async () => {
            try {
                const dataUrl = await getDataUrl(dbId, studyId);
                dispatch({type: 'SET_AUDIO', data: dataUrl});
            } catch (e) {
                console.error('Audio ' + dbId + ' could not be loaded: ' + e);
            } finally {
                setIsLoading(false);
            }
        };
        loadAudio();

        return () => {
            dispatch({type: 'SET_AUDIO', data: ''});
        };
    }, [dbId]);

    let content: JSX.Element;
    if (isLoading) {
        content = (<p className="media-loading">Audio wird geladen...</p>);
    } else if (!audioFile) {
        content = (<p >{props.showErrorMessage && `Audiodatei ${dbId} nicht gefunden.`}</p>);
    } else {
        content = (<audio controls={true} autoPlay={autoplay}>
            <source src={audioFile} />
        </audio>);
    }

    return content;
};
export default DbAudio;